import { useMemo } from 'react';
import { useState } from 'react';
import { Post } from 'Xhr/Xhr';

const CallPostRequest = async (url, auth = false, data) => {
  try {
    const response = await Post('POST', `${url}`, auth, {
      ...data,
    });
    return response?.data;
  } catch (error) {
    console.error('Error:', error);
  }
};

const GetPostResponse = (
  url,
  auth = false,
  data,
  watcher = '',
  validate = true
) => {
  const [responseData, setresponseData] = useState(null);

  useMemo(() => {
    if (
      !Object.values(data).includes(undefined) &&
      validate
    )
      CallPostRequest(url, auth, data).then((response) => {
        setresponseData(response);
      });
  }, [
    JSON.stringify(url),
    JSON.stringify(auth),
    JSON.stringify(data),
    watcher,
    validate,
  ]);

  return responseData;
};

export default GetPostResponse;
